export default "__VITE_ASSET__DT3EUR5e__"